import { getListToRender } from './getListToRender';
export var moveFocusOutside = function (_a) {
    var state = _a.state, searchAttributes = _a.searchAttributes, maxRenderedDropdownElements = _a.maxRenderedDropdownElements, dropdownList = _a.dropdownList, noMatchDropdownList = _a.noMatchDropdownList, searchMatcher = _a.searchMatcher, displayAttribute = _a.displayAttribute, onChange = _a.onChange;
    var listToRender = getListToRender({
        inputValue: state.inputValue,
        searchAttributes: searchAttributes,
        maxRenderedDropdownElements: maxRenderedDropdownElements,
        dropdownList: dropdownList,
        noMatchDropdownList: noMatchDropdownList,
        searchMatcher: searchMatcher,
        showAllItemsInDropdown: true,
    }).listToRender;
    var shouldEmptySelectedItem = state.inputValue === '' && !!state.selectedItem;
    var shouldAutomaticallySetSelectedItem = state.listToRender.length === 1 &&
        searchAttributes
            .map(function (searchAttribute) {
            var _a;
            return state.listToRender[0][searchAttribute] ===
                ((_a = state.selectedItem) === null || _a === void 0 ? void 0 : _a[searchAttribute]);
        })
            .includes(false) &&
        state.highlightedIndex !== -1;
    var selectedItem = state.selectedItem;
    if (shouldEmptySelectedItem) {
        onChange === null || onChange === void 0 ? void 0 : onChange(null);
        selectedItem = undefined;
    }
    else if (shouldAutomaticallySetSelectedItem) {
        onChange === null || onChange === void 0 ? void 0 : onChange(state.listToRender[0]);
        selectedItem = state.listToRender[0];
    }
    var inputValue = selectedItem ? selectedItem[displayAttribute] : '';
    return { inputValue: inputValue, selectedItem: selectedItem, listToRender: listToRender };
};
